import React, { useState, useEffect, useMemo } from "react";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BRAND_BY_HOST = [
  { test: /earthscan|earth-scan|earth\sscan|earthscan\.sobekglobal/i, brand: "earthscan" },
  { test: /sobekglobal|sobek/i, brand: "sobek" },
  { test: /dronepilott|dronepilot|drone/i, brand: "drone" },
];

function detectBrandFromHost() {
  const host = (typeof window !== "undefined" ? window.location.hostname : "").toLowerCase();
  const hit = BRAND_BY_HOST.find((r) => r.test.test(host));
  return hit ? hit.brand : "earthscan"; // default
}

function buildLoginHref(brand) {
  const service = `${window.location.origin}/profile`;
  return `/login?brand=${encodeURIComponent(brand)}&service=${encodeURIComponent(service)}`;
}

const Header = ({
  popupOpen,     
  openPopupFully,
  setMapCenter,
  setMarkerPosition,
  selectedTab,
  setSelectedTab,

  // ✅ جديد (اختياري): لو الصفحة الأم بعتته، هنستخدمه مباشرة
  loginHref,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [allowShareTab, setAllowShareTab] = useState(false);

  // ✅ نحدد البراند مرة واحدة
  const brandKey = useMemo(() => detectBrandFromHost(), []);
  // ✅ لو مفيش prop من الأب، ابنِ لينك ذكي تلقائي
  const resolvedLoginHref = useMemo(
    () => loginHref || buildLoginHref(brandKey),
    [loginHref, brandKey]
  );

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch("https://countriesnow.space/api/v0.1/countries/positions");
        const data = await response.json();

        const countriesData = (data?.data || []).map((country) => ({
          name: country.name,
          latlng: [country.lat, country.long],
        }));

        setCountries(countriesData.sort((a, b) => a.name.localeCompare(b.name)));
      } catch (err) {
        console.error("Error:", err);
        setError(err);
        // Fallback بسيطة
        setCountries([
          { name: "United States", latlng: [37.0902, -95.7129] },
          { name: "Saudi Arabia", latlng: [23.8859, 45.0792] },
          { name: "Egypt", latlng: [26.8206, 30.8025] },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (value.length > 0) {
      const results = countries.filter((country) =>
        country.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCountries(results);
    } else {
      setFilteredCountries([]);
    }
  };

  const handleSelectCountry = (country) => {
    setSearchTerm(country.name);
    setFilteredCountries([]);
    setMapCenter(country.latlng);
    setMarkerPosition(country.latlng);
  };

  const navigate = useNavigate();

  // ✅ لو حبّيتي تستخدمِ navigate بدلاً من <a>، الاتنين صح
  const goToLogin = () => {
    // يدعم Query String عادي
    navigate(resolvedLoginHref);
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "70px",
        backgroundColor: "#2c2c2c",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "0 20px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
        zIndex: 10000,
        transition: "all 0.3s ease",
      }}
    >
      {/* ✅ استخدمي واحدة من الطريقتين: navigate أو anchor */}
      {/* 1) navigate: */}
      <a
  href={resolvedLoginHref}
        style={{
          backgroundColor: "#ff9f00",
          color: "#fff",
          padding: "6px 12px",
          border: "none",
          borderRadius: "5px",
          fontSize: "16px",
          cursor: "pointer",
          marginRight: "40px",
          position: "absolute",
          right: "10px",
        }}
      >
        LOGIN / SIGNUP
</a>
      {/* 2) أو Anchor مباشرة (تعليق/إلغاء حسب تفضيلك)
      <a
        href={resolvedLoginHref}
        style={{
          backgroundColor: "#1ba99e",
          color: "#fff",
          padding: "6px 12px",
          borderRadius: "5px",
          fontSize: "16px",
          textDecoration: "none",
          position: "absolute",
          right: "10px",
        }}
      >
        LOGIN / SIGNUP
      </a> */}

      {!popupOpen && (
        <button
          onClick={openPopupFully}
          style={{
            background: "none",
            border: "none",
            color: "white",
            fontSize: "30px",
            cursor: "pointer",
            marginRight: "20px",
          }}
          aria-label="Open panel"
        >
          &#9776;
        </button>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          flexGrow: 1,
        }}
      >
        {popupOpen && (
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={() => setSelectedTab("details")}
              style={{
                padding: "8px 16px",
                backgroundColor: selectedTab === "details" ? "#ff9f00" : "#444",
                color: selectedTab === "details" ? "#000" : "#fff",
                border: "none",
                borderRadius: "4px",
                minWidth: "180px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Details
            </button>
            <button
              onClick={() => {
                if (allowShareTab) setSelectedTab("share");
              }}
              style={{
                padding: "8px 16px",
                backgroundColor: selectedTab === "share" ? "#ff9f00" : "#444",
                color: selectedTab === "share" ? "#000" : "#fff",
                border: "none",
                borderRadius: "4px",
                minWidth: "180px",
                fontWeight: "bold",
                cursor: "pointer",
                // opacity: allowShareTab ? 1 : 0.6,
              }}
              title={allowShareTab ? "" : "Apply في Details أولاً"}
            >
              Filters
            </button>
          </div>
        )}

        <img
          src="/asset15.png"
          alt="Earth Scan Logo"
          style={{
            height: "65px",
            objectFit: "contain",
            transition: "all 0.3s ease",
            marginLeft: popupOpen ? "20px" : "1px",
          }}
        />

        <div style={{ position: "relative", width: "300px" }}>
          <input
            type="text"
            placeholder="Search Country"
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              width: "80%",
              backgroundColor: "transparent",
              border: "none",
              borderBottom: "1px solid #aaa",
              color: "white",
              fontSize: "16px",
              padding: "8px 30px 8px 10px",
              outline: "none",
            }}
          />
          <Search
            size={18}
            color="#aaa"
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          />

        {filteredCountries.length > 0 && (
  <ul
    style={{
      position: "absolute",
      top: "100%",
      left: 0,
      width: "100%",
      backgroundColor: "white",
      boxShadow: "0px 2px 5px rgba(0,0,0,0.3)",
      borderRadius: "8px",
      listStyle: "none",
      padding: "5px",
      margin: 0,
      maxHeight: "200px",
      overflowY: "auto",
      zIndex: 10001,
    }}
  >
    {filteredCountries.map((country, index) => (
      <li
        key={index}
        onClick={() => handleSelectCountry(country)}
        style={{
          padding: "8px",
          cursor: "pointer",
          borderBottom: "1px solid #ddd",
          fontSize: "14px",
        }}
      >
        {country.name}
      </li>
    ))}
  </ul>
)}

        </div>
      </div>
    </div>
  );
};

export default Header;
